import React from "react";
import { PREP_COLORS, STATUS_COLORS } from "../lib/constants";

export function StatusPill({ value, kind = "status" }) {
  const map = kind === "prep" ? PREP_COLORS : STATUS_COLORS;
  const cls = map[value] || "text-slate-700 bg-slate-100";
  return (
    <span
      className={`rg-pill border-current ${cls}`}
      data-testid={`pill-${kind}-${(value || "").toLowerCase().replace(/\s+/g, "-")}`}
    >
      {value || "—"}
    </span>
  );
}
